<!--
 * @Description: 批改线下作业
 * @Author: PF
 * @Date: 2022-09-23 11:53:32
 * @LastEditors: PF
 * @LastEditTime: 2023-08-31 13:38:16
-->
<template>
  <div class="zuo-ye">
    <el-dialog class="w900 hp80" :model-value="openXianXiaZuoYe" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">批改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openXianXiaZuoYe', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" class="wp100 hp100" label-width="140px">
        <el-container class="hp100">
          <el-aside width="200px">
            <div class="ping-jia">
              评价：
              <el-input v-model="ruleForm.py" :rows="10" type="textarea" resize="none" />
            </div>
          </el-aside>
          <el-main class="pt0 pr0 pb0">
            <div v-if="zuoYe.xianXiaZuoYe">
              <div class="mt10" style="display:flex">
                <div class="w70">题目</div>
                <!-- <div><p style="white-space: pre-wrap; text-indent:0;" v-html="zuoYe.xianXiaZuoYe.stzw"></p></div> -->
                <teditor ref="editor" v-model="zuoYe.xianXiaZuoYe.stzw" :height="200" :toolbar="''" :disabled="true" />
              </div>
              <div class="mt10" style="display:flex">
                <div class="w70">解答</div>
                <teditor ref="editor" v-model="zuoYe.xianXiaZuoYe.jd" :height="200" :toolbar="''" :disabled="true" />
              </div>
              <ul class="mt10" v-if="zuoYe.xianXiaZuoYe.listFj" style="display: flex;flex-wrap: wrap;">
                <li v-for="(item, index) in zuoYe.xianXiaZuoYe.listFj" :key="index" class="w100 h100 mr10 mb10 demo-image__preview">
                  <el-image class="wp100 hp100" :src="fileurl+item" :zoom-rate="1.2" :preview-src-list="srcList" :initial-index="4" fit="cover" />
                </li>
              </ul>
            </div>
            <div class="mt10" style="display:flex">
              <div class="w70 mr10">总分数</div>
              <div>{{ zuoYe.xianXiaZuoYe.fz }}分</div>
            </div>
            <div class="mt10" style="display:flex;align-items: center;">
              <div class="w70">得分</div>
              <div class="w150">
                <el-input-number v-model="ruleForm.pf" :min="0" :precision="1" />
              </div>
            </div>
          </el-main>
        </el-container>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openXianXiaZuoYe', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
    <el-backtop :right="100" :bottom="100" />
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { loadSelect, submitForm, closeWindow } from '@/api/common.js'
import teditor from '@/components/teditor.vue'

const props = defineProps({
  openXianXiaZuoYe: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openXianXiaZuoYe', 'ReturnData'])
const fileurl = ref()
const ruleFormRef = ref(null)
const ruleForm = ref({
  xszyid: '',
  pf: '',
  py: '',
  xianXiaZuoYe: { listFj: [] }
})
const zuoYe = ref({ xianXiaZuoYe: { listFj: [] } })
const srcList = ref([])

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/ziyuanku/xueshengzuoye/jiaoshipigaixianxia',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openXianXiaZuoYe', emits, true)
    }
  })
}
watch(
  () => props.openXianXiaZuoYe,
  () => {
    if (props.openXianXiaZuoYe) {
      
      fileurl.value = process.env.VUE_APP_BASE_API
      ruleForm.value.xszyid = props.row.id
      loadSelect({
        url: '/api/v2/ziyuanku/xueshengzuoye/xueshengzuoyexiangqing',
        data: zuoYe,
        parms: { xszyid: props.row.id },
        loadSuccess: function (res) {
          if (res.data.xianXiaZuoYe.listFj) {
            srcList.value = res.data.xianXiaZuoYe.listFj.map(item => fileurl.value + item)
          }
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
:deep(.demo-image__error .image-slot) {
  font-size: 30px;
}
:deep(.demo-image__error .image-slot .el-icon) {
  font-size: 30px;
}
.demo-image__error .el-image {
  width: 90%;
  height: 200px;
}
.dao-hang {
  height: calc(100% - 257px);
  overflow: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  :deep(.el-link) {
    margin: 5px;
    width: 40px;
    height: 40px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
  }
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
}
.biao-ti {
  padding: 15px 0;
  font-size: 16px;
}
</style>
